<template>
  <b-row class="kpi-cards mb-2">
    <b-col
      v-for="card in cards"
      :key="card.key"
      cols="6"
      md="3"
      class="mb-1 mb-md-0"
    >
      <b-card
        class="kpi-card h-100 text-center"
        body-class="kpi-body"
      >
        <download-menu
          class="kpi-dl"
          :filename="card.key"
          :rows="[{ Metric: card.label, Value: card.raw }]"
          :columns="[{ key: 'Metric', label: 'Metric' }, { key: 'Value', label: 'Value' }]"
        />
        <div
          class="kpi-icon-wrap mb-1"
          :class="`kpi-icon--${card.color}`"
        >
          <feather-icon
            :icon="card.icon"
            size="20"
          />
        </div>
        <div class="kpi-value">
          {{ card.formatted }}
        </div>
        <div class="kpi-label">
          {{ card.label }}
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'
import DownloadMenu from './DownloadMenu.vue'
import { formatCurrency, formatInt } from '../analyticsFormat'

export default {
  name: 'AnalyticsKPICards',
  components: {
 BRow, BCol, BCard, DownloadMenu,
},
  props: {
    kpis: {
      type: Object,
      default: () => ({
        orders: 0, productsSold: 0, unitsSold: 0, totalSales: 0,
      }),
    },
  },
  computed: {
    cards() {
      return [
        {
          key: 'orders',
          label: 'Orders',
          icon: 'ShoppingBagIcon',
          color: 'blue',
          formatted: this.formatInt(this.kpis.orders),
          raw: this.kpis.orders,
        },
        {
          key: 'products_sold',
          label: 'Products Sold',
          icon: 'PackageIcon',
          color: 'purple',
          formatted: this.formatInt(this.kpis.productsSold),
          raw: this.kpis.productsSold,
        },
        {
          key: 'units_sold',
          label: 'Units Sold',
          icon: 'LayersIcon',
          color: 'green',
          formatted: this.formatInt(this.kpis.unitsSold),
          raw: this.kpis.unitsSold,
        },
        {
          key: 'total_sales',
          label: 'Total Sales',
          icon: 'TrendingUpIcon',
          color: 'amber',
          formatted: this.formatCurrency(this.kpis.totalSales),
          raw: this.kpis.totalSales,
        },
      ]
    },
  },
  methods: {
    formatInt,
    formatCurrency,
  },
}
</script>

<style lang="scss" scoped>
.kpi-card {
  border: 1px solid #dbeafe;
  border-radius: 10px;
  overflow: visible;
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  ::v-deep .card-body { overflow: visible; }

  @media (prefers-reduced-motion: no-preference) {
    &:hover { box-shadow: 0 4px 16px rgba(30, 64, 175, 0.12); }
  }
  @media (prefers-reduced-motion: reduce) {
    &:hover { box-shadow: 0 4px 16px rgba(30, 64, 175, 0.12); }
  }

  .kpi-icon-wrap {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;

    // All combos ≥ 4.5:1 (WCAG AA icon colour against light bg)
    &.kpi-icon--blue   { background: #dbeafe; color: #1e40af; } // 5.1:1
    &.kpi-icon--purple { background: #ede9fe; color: #5b21b6; } // 5.2:1
    &.kpi-icon--green  { background: #dcfce7; color: #15803d; } // 4.5:1
    &.kpi-icon--amber  { background: #fef3c7; color: #b45309; } // 4.5:1
  }

  .kpi-value {
    font-size: 1.75rem;
    font-weight: 700;
    color: #1e3a8a !important;
    line-height: 1.2;
    margin-bottom: 4px;
    font-variant-numeric: tabular-nums;
  }

  .kpi-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
}

.kpi-body {
  position: relative;
  padding: 12px 8px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: visible;
}

.kpi-dl {
  position: absolute;
  top: 4px;
  right: 4px;
}
</style>
